import React from 'react';
import './fecloud.scss';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Format,
  Pager,
  Paging,
  FilterRow,
  Lookup,
  Editing,
  Selection,
  Toolbar,
  Item,
  Summary,
  GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';


import {handleAuthError, useCheckUserAuthentication,fetchLookup,tipoFEOptions,} from '../../globals';
import { DateBox } from 'devextreme-react/date-box'; 
import { useState, useEffect, useMemo } from "react";
import {Button as ToolbarButton} from 'devextreme-react/button';

import notify from 'devextreme/ui/notify';

import { confirm } from 'devextreme/ui/dialog';

const debug = process.env.ENTITY_DEBUG;
const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OpenAPI'



export default function FECloud() {

  const user = useCheckUserAuthentication();

  const defaultStartDate = new Date();
  defaultStartDate.setMonth(defaultStartDate.getMonth() - 1);
  const defaultEndDate = new Date();
  const [tipiDocumento, setTipoDocumento] = useState({});
  const [currentRow, setCurrentRow] = useState(1);
  const [currentUuid, setCurrentUuid] = useState();
  const [isRowSelected, setIsRowSelected] = useState(false);
  //const [{ start, end }] = React.useState(getQuarterDates);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);

  const [typeFilter, setTypeFilter] = useState('1');

  const remoteDataSource = useMemo(() => {
    return createStore({
      key: 'uuid',
      loadUrl: serviceUrl + '/OpenAPIInvoices',

      onBeforeSend: (method, ajaxOptions) => {
        if (method === "load") {
          const payload = ajaxOptions.data;
          payload.values = JSON.stringify({
            type: typeFilter,
            createdAtAfter: startDate,
            createdAtBefore: endDate,
          });
          ajaxOptions.data = payload;
        }

        ajaxOptions.headers = {
          Authorization: `Bearer ${user.token}`
        };
      },
      errorHandler: (error) => {
        handleAuthError(error);
      }

    });
  }, [typeFilter, startDate, endDate, user.token]);



  useEffect(() => {

    const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_TipoDocumentiFiscali';
    var newUrl13 =  newServiceUrl13 + "/GetAction";
 
    const fetchData = async () => {

      if (!user?.token) {
      return;
      }

      try {

        const response13 = await fetch(newUrl13);
        const json13 = await response13.json();
        if (debug === 1)
          console.log(json13);
        setTipoDocumento(json13);


      } catch (error) {
        console.log("error", error);
      }
      
    };
      fetchData();
  }, [user?.token]); // Aggiorna se il token cambia


  const startDateValueChanged = (e) => {
    setStartDate(e.value);
  };
  const endDateValueChanged = (e) => {
    setEndDate(e.value);
  };

  function downloadXML(e) {
    streamXML(currentUuid);
  };


 async function streamXML(uuid) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_WEBAPP_DOMAIN}/api/OpenAPI/DownLoadXMLFE/${uuid}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      }
    );

    if (!response.ok) {
      const error = await response.json();
      notify(error.message || 'Errore nel download XML', 'error', 5000);
      return;
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `XML_${uuid}.xml`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

  } catch (err) {
    notify('Errore di rete o server non disponibile', 'error', 5000);
  }
}




  function importSupplierInvoice(e) {
    let result = confirm("<i>Procedere con l'importazione in Fatture Fornitori dell'elemento selezionato?</i>", "Importa Fattura");
    result.then((dialogResult) => {
      if  (dialogResult) {
        importaFattura(currentUuid);
      }
    });
  };

  function importaFattura(uuid) {
  
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OpenAPI/ImportInvoiceFE/' + uuid;

    const requestOptions = {
      method: 'GET',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;             
      })
      .then(data => {
        notify(data.message, data.success ? 'success' : 'error', 5000);
      })
      .catch(error => { notify(error, 'error', 10000); });
  };  

  function print(e) {
    printInvoice(currentUuid);
  }
 

  async function printInvoice(uuid) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_WEBAPP_DOMAIN}/api/OpenAPI/ExportInvoicePDF/${uuid}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      }
    );

    if (!response.ok) {
      const error = await response.json();
      notify(error.message || 'Errore nel download XML', 'error', 5000);
      return;
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `PDF_${uuid}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

  } catch (err) {
    notify('Errore di rete o server non disponibile', 'error', 5000);
  }
}

  const selectBoxOptions = {
    width: 210,
    items: tipoFEOptions,
    valueExpr: 'id',
    displayExpr: 'desc',
    placeholder:"<Tipo>",
    showClearButton:false,
    onValueChanged: (args) => {
      setTypeFilter(args.value);
    },
    value: typeFilter
  };

  function onRowSelectionChanged({ selectedRowsData }) {

    const data = selectedRowsData[0];
    if (data != null) {

      setCurrentRow(data.id);
      setCurrentUuid(data.uuid);
      //console.log("SELECTED " + data.uuid);
      setIsRowSelected(true);
    } else {
      setIsRowSelected(false);
      setCurrentUuid(null);
    }
 
  }


  return(
  <React.Fragment>
    <h2 className={'content-block'}>FE in Cloud</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          showBorders={true}
          onSelectionChanged={onRowSelectionChanged}
        >
          <Toolbar>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='import'
                hint='Importa in Fatture Fornitori'
                onClick={importSupplierInvoice}
                disabled={!isRowSelected || typeFilter === '0'} />
            </Item>
             <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='export'
                hint='XML'
                onClick={downloadXML}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='print'
                hint='Pdf'
                onClick={print}
                disabled={!isRowSelected}
                visible={true} />
            </Item>
            <Item location="after">
              <div style={{ paddingRight: 8, paddingLeft: 8, fontWeight: 600 }}>
                Periodo notifica:
              </div>
            </Item>
            <Item location="after">
              <DateBox
                value = {startDate}
                showClearButton={false}
                onValueChanged={startDateValueChanged}
              />
            </Item>
            <Item location="after">
              <DateBox
                value = {endDate}
                showClearButton={false}
                onValueChanged={endDateValueChanged}
              />
            </Item>
             <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>
           </Toolbar>
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Selection mode="single" />
          <Editing
            mode="row"
            useIcons={true}
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={false}     
          />
          <Column dataField="uuid" caption= "Id" visible={true} width={300}/>
          <Column dataField="createdAt" caption= "Data creazione" dataType="date" format= {'dd/MM/yyyy hh:mm:ss'}/>
          <Column dataField="categoriaDocumento" caption="Tipo Documento"  visible={true}>
            <Lookup dataSource={tipiDocumento} valueExpr="codice" displayExpr="categoria" />
          </Column>
          <Column dataField="tipoDocumento" caption="Tipo" visible={false} >
            <Lookup dataSource={tipoFEOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="numero" caption= "Num. Documento"/>
          <Column dataField="data" caption= "Data Documento" dataType="date" format= {'dd/MM/yyyy'} width={140}/>
          
          <Column dataField="totale"  width={100} caption="Importo">
            <Format type="fixedPoint" precision={2} />
          </Column>
          
          
          <Column dataField="mittente" caption= "Mittente"/>
          <Column dataField="destinatario" caption= "Destinatario"/>
          <Column dataField="imported" caption= "Importata" visible={typeFilter !== '0'} width={90}/>
          <Column dataField="ultimaNotifica" caption= "Ultima Notifica" visible={typeFilter !== '1'}/>
          <Column dataField="ultimaDataNotifica" caption= "Ultima Data notifica" dataType="date" format= {'dd/MM/yyyy hh:mm:ss'} visible={typeFilter !== '1'}/>
   
        </DataGrid>  

      </div>
    </div>
  </React.Fragment>
  )

};
